import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { api } from './client'

export function setupInterceptors(getToken: () => string | null, onUnauthorized: () => void): void {
  api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = getToken()
      if (token) {
        config.headers.Authorization = token
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    (response: AxiosResponse) => response,
    error => {
      if (error.response?.status === 401) {
        onUnauthorized()
      }

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Request failed with status ${error.response?.status || 'unknown'}`

      return Promise.reject(new Error(message))
    }
  )
}
